/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuthAppTypeEnum } from './oAuthAppTypeEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface OAuthAppOperationSpec { 
    /**
     * Organisation Id.
     */
    org_id: string;
    service_type: ServiceTypeEnum;
    authorization_oauth_app_type: OAuthAppTypeEnum;
}
export namespace OAuthAppOperationSpec {
}


